<template>
  <div v-if="!startBroadcastStatus">
    <!-- <v-btn @click="startLiveStream"> Canlı yayını başlat</v-btn>
    <v-btn @click="joinLiveStream"> Canlı yayını izle</v-btn> -->
    <div v-if="!startStatus">
      Yayına bağlanılamadı, lütfen daha sonra tekrar deneyiniz.
    </div>
  </div>

  <div v-else>
    <session-component
      :sessionId="sessionId"
      :apiKey="apiKey"
      :token="token"
      :publisher="true"
    />
  </div>
</template>

<script>
import BroadcastService from "../../services/BroadcastService";
import SessionComponent from "../../components/LiveStream/Session.vue";
export default {
  data() {
    return {
      startStatus: false,

      sessionId: null,
      apiKey: null,
      token: null,
    };
  },
  mounted() {
    this.startLiveStream();
  },
  components: {
    SessionComponent,
  },
  methods: {
    startLiveStream() {
      BroadcastService.getCredentials()
        .then((res) => {
          this.apiKey = res.data.ApiKey.toString();
          this.sessionId = res.data.SessionId;
          this.token = res.data.Token;
          this.startStatus = true;
          this.startBroadcast();
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },

    startBroadcast() {
      setTimeout(() => {
        BroadcastService.startBroadcast()
          .then((res) => {})
          .catch((err) => {
            showError(err);
          })
          .then(() => {});
      }, 5000);
    },

    joinLiveStream() {
      console.log("join Live Stream");
      this.$router.push("/joinLiveStream");
    },
  },
  computed: {
    startBroadcastStatus() {
      if (this.startStatus && this.apiKey && this.sessionId && this.token) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
};
</script>
